import { Result, Schema, SchemaIssue } from "effect";

// KV key size limit per Cloudflare docs.
export const MAX_KEY_BYTES = 512;

/**
 * Validates a KV key and returns an error message if invalid, or null if
 * valid.
 */
export const KvKey = /* @__PURE__ */ (() => Schema.String.check(
  Schema.makeFilter(value => value.trim().length > 0, { message: "Key is required" }, true),
  Schema.makeFilter(value => {
    const length = new TextEncoder().encode(value).length;
    return length <= MAX_KEY_BYTES || `Key must be ${MAX_KEY_BYTES} bytes or less (currently ${length} bytes)`;
  })
).pipe(Schema.brand("kv-key")))();
export type KvKey = typeof KvKey.Type;

const decode = /* @__PURE__ */ (() => Schema.decodeUnknownResult(KvKey))();
const formatIssue = SchemaIssue.makeFormatterDefault();
export const validateKey = (key: string): string | null => Result.match(decode(key), {
  onSuccess: () => null,
  onFailure: error => formatIssue(error.issue)
});
